module.exports = __webpack_public_path__ + "img/mobile_map_sernobi.f68ba7bb.svg";